import imagesList from '@/constant/images-list';

import { StepItem } from './type';

export const STEPS: StepItem[] = [
  {
    id: 1,
    title: 'انتخاب سایت آماده به همراه هاست رایگان',
    description: 'محصول مورد نظر و خدمات دلخواه‌تان از جمله هاست رایگان را انتخاب ‌کنید.',
    image: imagesList.images.readySite1,
  },
  {
    id: 2,
    title: 'ثبت سفارش با پرداخت اقساطی',
    description: 'می‌توانید با انتخاب روش قسطی، باکمترین هزینه محصول خود را خریداری کنید.',
    image: imagesList.images.readySite2,
  },
  {
    id: 3,
    title: 'وارد کردن دامنه خریداری شده شما',
    description:
      'دامنه خریداری شده خود و اطلاعات مورد نیاز برای راه‌اندازی سایت را ثبت ‌کنید.',
    image: imagesList.images.readySite3,
  },
  {
    id: 4,
    title: 'نصب رایگان توسط پشتیبانی محصول',
    description: 'نصب و تنظیمات اولیه سایت شما توسط پشتیبانی محصول انجام خواهد شد.',
    image: imagesList.images.readySite4,
  },
  {
    id: 5,
    title: 'تحویل سایت در کوتاه‌ترین زمان ممکن',
    description:
      'می‌توانید بعد از تحویل، محتوا و رنگ‌ها را متناسب با کسب‌و‌کار خود منتشر کنید.',
    image: imagesList.images.readySite5,
  },
];
